/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { propsUtils } from '@ba-ui-toolkit/utils';
import THead from './THead';
import TBody from './TBody';
import TBodyDnD from './TBodyDnD';
import styles from './simpletable.scss';

const stClassName = styles.stClassName.replace(/"/g, '');
const { sanitize } = propsUtils;

export default class SimpleTable extends Component {
	static propTypes = {
		/** Is the number of rows you plan to load in table */
		rowLength: PropTypes.number,
		/** Custom class name(s) */
		className: PropTypes.string,
		/** Set to column index for the first idnetifiable td that has text in a row. (accessibility requirement) */
		colToAddScopeRow: PropTypes.number,
		/** A brief descriptive text, that indicates the content of that table (accessibility requirement) */
		caption: PropTypes.string,
		/** Is the number of columns you plan to load in table */
		colLength: PropTypes.number,
		/** Pass a callback function with row and column index as arguments */
		cellRenderer: PropTypes.func,
		/** Pass a callback function with column index as arguments */
		headerRenderer: PropTypes.func,
		/** Pass a callback function with arguments as source and target row index respectively */
		onRowMove: PropTypes.func,
		/** Pass a callback function with arguments as row index. Triggers on row mouse out */
		onRowOut: PropTypes.func,
		/** Set width division as key-value pair */
		widthDivision: PropTypes.object,
		/** Set height of table */
		height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		/** Boolean value to make rows draggable */
		draggable: PropTypes.bool,
		/** Pass a callback function with arguments as rowIndex. Triggers on row mouse over. */
		onRowHover: PropTypes.func,
		/** Pass a callback function with arguments as rowIndex. Triggers on row click. */
		onRowClick: PropTypes.func,
	};
	onSelect(row) {
		if (this.tbodydnd) {
			this.tbodydnd.onSelect(row);
		} else if (this.tbody) {
			this.tbody.onSelect(row);
		}
	}

	render() {
		const {
			rowLength,
			colToAddScopeRow,
			caption,
			className,
			colLength,
			cellRenderer,
			headerRenderer,
			onRowMove,
			onRowOut,
			widthDivision,
			height,
			draggable,
			onRowHover,
			onRowClick,
			...others
		} = this.props;
		const tHeaderProps = {
			colLength,
			headerRenderer,
			widthDivision,
		};
		const tBodyProps = {
			rowLength,
			colToAddScopeRow,
			colLength,
			cellRenderer,
			onRowMove,
			onRowOut,
			widthDivision,
			height,
			draggable,
			onRowHover,
			onRowClick,
		};

		return (
			<table
				{...sanitize(others, SimpleTable)}
				className={`${stClassName}-fixed-headers ${className}`}
			>
				{caption && <caption className={`${stClassName}-caption`}>{caption}</caption>}
				<THead {...tHeaderProps} />
				{!this.props.draggable && (
					<TBody
						ref={r => {
							this.tbody = r;
						}}
						{...tBodyProps}
					/>
				)}
				{this.props.draggable && (
					<TBodyDnD
						ref={r => {
							this.tbodydnd = r;
						}}
						{...tBodyProps}
					/>
				)}
			</table>
		);
	}
}
